import { StyleSheet, Dimensions } from "react-native";

var win = Dimensions.get("window");

export default StyleSheet.create({
    container:{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    innerContainer:{
        width: 500,
        height:200,
        flexDirection:"row",
    },
    leftContainer:{
        width: 250,
        flex:1
    }
});